module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp/bg_header-28316bcce2cf051aa13edc0b8398c2bd.png";